import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { FormValidity, PageLayouts, Skeletons, ViewPanel } from "components/common";
import EditSalariesFormContainer from "./forms/editSalariesFormContainer";
import EditSalaryFooter from "./editSalaryFooter";
import { Grid, Portal } from "@mui/material";
import { useEmployeeHelpers } from "components/employee";
import { useSalaryService } from "serviceHooks";
import useSalaryPermissions from "./hooks/useSalaryPermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const EditSalaries: React.FC = (props) => {
  const salaryService = useSalaryService();
  const [salarySettings, setSalarySettings] = React.useState<WintSuperkollAPIModel.EmployeeItem[]>();
  const [loading, setLoading] = React.useState<boolean>(true);

  const formRef = React.useRef<FormHandles>(null);

  const { canManageEmployeeSalary, canBulkEditSalaries } = useEmployeeHelpers();
  const { isSalaryAdmin } = useSalaryPermissions();

  React.useEffect(() => {
    loadSalarySettings();
  }, []);

  const loadSalarySettings = () => {
    setLoading(true);
    salaryService
      .getEmployeesSalarySettings()
      .then((settings) => {
        // Filter out employees without salary settings
        setSalarySettings((settings.employees ?? []).filter((s) => s.permissions?.employee === true));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSaveClick = async () => {
    return formRef.current && formRef.current.submit();
  };

  const footerMount = () => document.getElementById("reportFooterContainer");

  return (
    <PageLayouts.DashboardLayout<any>
      entityKey={0}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.Salaries)}
      hasPermissions={canBulkEditSalaries}
      className={cssExports.fullHeight}
    >
      <Grid item container>
        {loading ? (
          <ViewPanel fitContent appearance="sm">
            <Skeletons.TableSkeleton />
          </ViewPanel>
        ) : salarySettings ? (
          <FormValidity
            render={(isValid, onValidityChange, isDirty, onDirtyChange) => (
              <>
                <EditSalariesFormContainer
                  ref={formRef}
                  settings={
                    isSalaryAdmin ? salarySettings : salarySettings.filter((s) => canManageEmployeeSalary(s.id))
                  }
                  onFormDirtyChange={onDirtyChange}
                />
                <Portal container={footerMount()}>
                  <EditSalaryFooter onSaveClick={onSaveClick} isDirty={isDirty} />
                </Portal>
              </>
            )}
          />
        ) : (
          <></>
        )}
      </Grid>
    </PageLayouts.DashboardLayout>
  );
};

export default EditSalaries;
